import SplitPageCta from '../common/SplitPageCta'
import { servicesImages } from '../../assets/images'
import { servicesCta } from '../../data/servicesPageData'

function ServicesPageCta() {
  const { title, description, primaryCta, secondaryCta } = servicesCta

  return (
    <SplitPageCta
      sectionClass="services-page-cta"
      panelClass="services-page-cta__panel"
      title={title}
      description={description}
      primaryCta={primaryCta}
      secondaryCta={secondaryCta}
      imageSrc={servicesImages.ctaChess}
    />
  )
}

export default ServicesPageCta
